@if (data.title) {
  <h2 class="text-2xl slg:text-3xl font-700 m-0">{{ data.title }}</h2>
  <effy-liseret [size]="liseretSize" />
}
<p class="text-xl slg:text-2xl font-300 m-0">{{ data.chapo }}</p>
<div class="mt-[32px] slg:mt-[56px]" [ngClass]="data.color ? 'discovery__card-color--' + data.color : ''">
  <nscf-cards-discovery-categorie [cards]="data.cards" [color]="data.color"></nscf-cards-discovery-categorie>
</div>
